import { BaseController } from "../../../common/base/controller";
import { SalutationTypes, TitleTypes } from "./userForm.constants";

class UserFormController extends BaseController {
	constructor(controllerService, $scope, userFormService, configService) {
		"ngInject";
		super({
			controllerService,
			$scope,
			userFormService,
			configService,
		});
	}

	get askForKundenNummer() {
		return this.configService.isFeatureActive(this.Features.askForKundennummer);
	}

	$onInit() {
		// need this to determine which field has error.
		this.id = this.$scope.$id;

		// Setup language specific options like date format for the datepicker
		this.dateOptions = {
			dateFormat: "dd.MM.yyyy",
			showWeeks: false,
		};
		this.setLanguageOptions().then(() => {
			this.dateOptions.dateFormat = this.languageOptions.mediumDate;
		});

		this.initErrorMessages();
		this.originalUser = angular.copy(this.user);

		this.salutations = SalutationTypes;
		this.titles = TitleTypes;

		let dates = this.getMinMaxDate();
		this.dateOptions.initDate = new Date(dates.initDate);
		this.dateOptions.maxDate = new Date(dates.minDate);
		this.dateOptions.minDate = new Date(dates.maxDate);

		// TODO set feature flags here
		this.isTinRequired = this.isTinRequired || false;
		this.isUserTitleRequired = false;
		this.showUserTitle = true;
	}

	initErrorMessages() {
		// error message keys
		let formErrorTypes = [
			"salutation",
			"firstName",
			"lastName",
			"birthday",
			"tin",
			"address",
			"zipCode",
			"city",
			"email",
			"kundennummer",
		];

		this.messages = {};
		for (let index in formErrorTypes) {
			this.messages[formErrorTypes[index]] = {
				required: "app.ownerState.error." + formErrorTypes[index],
			};
			this.messages[formErrorTypes[index]][formErrorTypes[index]] =
				"app.ownerState.error." + formErrorTypes[index];
		}

		this.messages.birthday.parse = "app.ownerState.error.birthday";
		this.messages.birthday.date = "app.ownerState.error.birthday";
		this.messages.birthday.dateDisabled =
			"app.ownerState.error.birthday.dateDisabled";
		this.messages.birthday.min = "app.ownerState.error.birthday.minvalue";
		this.messages.birthday.max = "app.ownerState.error.birthday.maxvalue";
		this.messages.postcode = {
			required: "app.ownerState.error.zipCode",
			postcode: "app.ownerState.error.zipCodeLength",
		};
	}
}

export default UserFormController;



// WEBPACK FOOTER //
// ./src/app/common/ui/userForm/userForm.controller.js